"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var float_converter_1 = require("../../client/impl/converter/body/float-converter");
var number_decoder_1 = require("../../client/impl/converter/body/number-decoder");
var string_decoder_1 = require("../../client/impl/converter/body/string-decoder");
var boolean_decoder_1 = require("../../client/impl/converter/body/boolean-decoder");
var ipv4_string_decoder_1 = require("../../client/impl/converter/body/ipv4-string-decoder");
var mac_address_string_decoder_1 = require("../../client/impl/converter/body/mac-address-string-decoder");
var LSB = false;
exports.PrimitiveConverterMap = {
    "string": string_decoder_1.StringConverter.ascii(),
    "ascii": string_decoder_1.StringConverter.ascii(),
    "utf8": new string_decoder_1.StringConverter("utf-8"),
    "integer_uint8": number_decoder_1.NumberConverter.uint8Instance(LSB),
    "integer_uint16": number_decoder_1.NumberConverter.uint16Instance(LSB),
    "integer_uint32": number_decoder_1.NumberConverter.uint32Instance(LSB),
    "integer_int8": number_decoder_1.NumberConverter.int8Instance(LSB),
    "integer_int16": number_decoder_1.NumberConverter.int16Instance(LSB),
    "integer_int32": number_decoder_1.NumberConverter.int32Instance(LSB),
    "float": float_converter_1.FloatConverter.instance32(),
    "boolean": boolean_decoder_1.BooleanConverter.instanceBit0(),
    "string_ipv4": ipv4_string_decoder_1.Ipv4StringConverter.instance(),
    "string_ipv4mask": ipv4_string_decoder_1.Ipv4StringConverter.instance(),
    "string_macaddress": mac_address_string_decoder_1.MacAddressStringConverter.instance(),
};
